<template>
  <CCard class="dataTable mt-5 mb-5" style="border: 1px solid #dee2e6; padding: 20px 30px">
    <CRow class="pt-2 pb-4">
      <CCol class="d-flex flex-column">
        <h2 class="titlePage font-weight-normal text-capitalize">
          {{ $t('campaign.campaignList.header1') }}
        </h2>
      </CCol>
      <CCol class="d-flex justify-content-end">
        <Engagement :engagementResultType="engagementResultType" :noDataTranslation="engagementNoDataTranslation" infoLeft />
      </CCol>
    </CRow>

    <CCardHeader class="dataTable__header d-flex justify-content-between px-0 pb-3">
      <div class="dataTable__countContants">
        <h3 class="font-weight-normal text-gray-700 mt-3 d-flex align-items-sm-center">
          {{ totalRecords || 0 }}
          <span class="font-sm font-weight-normal text-uppercase ml-2">{{ $t('campaign.campaignList.campaign') }}</span>
        </h3>
      </div>
      <div class="dataTable__search">
        <CInput
          type="search"
          :placeholder="$t('campaign.campaignList.placeholder-search')"
          addInputClasses="pl-5"
          class="iconSearchPlaceholder pb-0"
          v-model="searchName"
          @input="searchByName()"
        >
        </CInput>
      </div>
      <div class="dataTable__buttonLink">
        <button
          v-if="(hasAudience && totalRecords > 0) || this.filters.Status.length > 0"
          class="btn btn-primary px-5 py-3 font-weight-bold"
          tag="button"
          @click="$router.push({ name: 'campaign' })"
          :class="hasAudience ? '' : 'disabled'"
        >
          {{ $t('campaign.campaignList.button.createCampaign') }}
        </button>
      </div>

      <!-- <button @click="testeAcc">acc</button> -->
    </CCardHeader>
    <transition name="fade">
      <MenssageAlert :messages="messages" />
    </transition>
    <template v-if="totalRecords > 0 || this.filters.Status.length || this.filters.DateTimeIni != null">
      <div class="mb-2 pl-3">
        <CRow>
          <CCol md="2">
            <CDropdown color="transparent pt-0" toggler-text="" class="m-1 p-0" style="cursor: pointer" addTogglerClasses="p-0 btn-dropdown">
              <template slot="toggler">
                <div class="text-gray-600 py-2">
                  {{ $t(`general.status.campaign.${statusSelected.toLowerCase()}`) }}
                  <CIcon name="arrow" class="text-gray-600 pt-1 ml-1" size="custom-size" :height="18" viewBox="0 0 32 32" />
                </div>
              </template>
              <CDropdownItem
                v-for="(status, index) in statusList"
                :key="index"
                class="text-decoration-none"
                @click.stop="checkFilter(status.value, status.label)"
                >{{ $t(`general.status.campaign.${status.label.toLowerCase()}`) }}</CDropdownItem
              >
            </CDropdown>
          </CCol>
          <CCol md="2">
            <CDropdown color="transparent pt-0" :caret="true" class="m-1 p-0" style="cursor: pointer" addTogglerClasses="p-0 btn-dropdown">
              <template slot="toggler">
                <div class="text-gray-600 py-2">
                  {{ $t('campaign.campaignList.text.search-for-dates') }}
                  <CIcon name="arrow" class="text-gray-600 pt-1 ml-1" size="custom-size" :height="18" viewBox="0 0 32 32" />
                </div>
              </template>
              <v-date-picker
                :locale="lang"
                mode="range"
                color="purple"
                v-model="dateRange"
                timezone="UTC"
                is-inline
                is-range
                addInputClasses="p-5 date-picker__input"
                @input="(date) => inputDate(date)"
              >
              </v-date-picker>
            </CDropdown>
          </CCol>
        </CRow>
      </div>
      <!-- rever  remove-scroll caos-->
      <CCardBody class="dataTable__body p-0">
        <CDataTable
          :responsive="false"
          :items="registers"
          :fields="headers"
          :table-filter="{ external: true, lazy: true }"
          items-per-page-select
          @row-clicked="(item) => check(item)"
          :items-per-page.sync="itemsPerPage"
          @pagination-change="paginationChange"
          :active-page="1"
          hover
          :header="false"
          :loading="loading"
        >
          <template #loading>
            <div class="d-flex justify-content-center align-items-center dataTable__loading">
              <CSpinner class="my-3" color="primary" />
            </div>
          </template>

          <template #select="{ item }">
            <td>
              <CInputCheckbox name="check" class="text-center checkboxTable" :checked="item._selected" custom />
            </td>
          </template>

          <template #name="{ item }">
            <td class="py-4 pl-4 pr-5 font-weight-normal font-xl" style="vertical-align: middle">
              <CIcon
                v-if="item.campaignStatus == 'Balance-Updated' || item.notEnoughBalance"
                v-c-tooltip="{ content: $t('campaign.campaignList.balance-error'), placement: 'top' }"
                name="notificationAlert"
                style="color: #ff7040"
                size="custom-size"
                :height="20"
                viewBox="0 0 32 32"
              />
              {{ item.name }}
            </td>
          </template>

          <template #campaignStatus="{ item }">
            <td class="py-4 px-1 font-weight-bolder">
              <CBadge v-if="item.campaignStatus == 'Balance-Updated'" class="font-weight-normal px-3 py-2 font-base badge-Ready-to-Send">
                {{ $t(`general.status.campaign.ready-to-send`) }}
              </CBadge>
              <CBadge
                v-else-if="
                  item.campaignStatus != 'Calculating' && item.campaignStatus != 'Pending-Balance' && item.campaignStatus != 'Pending_Outbox_Dispatch'
                "
                class="font-weight-normal px-3 py-2 font-base"
                :class="'badge-' + item.campaignStatus"
                >{{ $t(`general.status.campaign.${item.campaignStatus.toLowerCase()}`) }}</CBadge
              >
              <div v-else class="font-weight-normal">
                <div style="display: inline-block">
                  <CSpinner color="primary" size="md" />
                </div>
                <div style="display: inline-block" class="pl-3">{{ $t('campaign.campaignList.text.calculating') }}...</div>
              </div>
            </td>
          </template>

          <template #recepients="{ item }">
            <td class="py-3 px-2 font-weight-normal text-center" style="vertical-align: middle">
              <div>{{ item.recepients > 0 ? item.recepients : '' }}</div>
              <div v-if="item.recepients > 0" class="font-smaller font-weight-normal">
                {{ $t('campaign.campaignList.text.recipients') }}
              </div>
            </td>
          </template>

          <template #channels="{ item }">
            <td class="py-3 px-3 font-weight-normal text-center" style="vertical-align: middle">
              <div class="mt-2 mb-1 d-flex">
                <div v-for="(channel, prop, index) in item.channels" :key="index" class="mx-1">
                  <CIcon class="mr-1" :name="prop" size="custom-size" :height="23" viewBox="0 0 32 32" />
                  <!-- <sup v-if="channel > 1">{{ channel }}</sup> -->
                  <!-- <CBadge shape="pill" color="gray-300" class="text-gray-600" v-if="channel > 1">{{ channel }}</CBadge> -->
                </div>
              </div>
            </td>
          </template>

          <template #user="{ item }">
            <td class="px-2 font-weight-normal font-sm" style="vertical-align: middle">
              <div class="">
                <CIcon name="userBgFull" class="text-gray-600 mr-1" :height="15" viewBox="0 0 32 32" />
                {{ $t('campaign.campaignList.text.by') }} {{ item.user }}
              </div>
            </td>
          </template>

          <template #action="{ item, index }">
            <td class="py-4 px-2 font-weight-normal text-center" style="vertical-align: middle">
              <div class="position-relative">
                <CButton
                  type="submit"
                  class="text-gray-600 delete-campaign-arpoone"
                  style="font-size: 14px"
                  v-if="item.campaignStatus == 'Draft' || item.campaignStatus == 'Canceled' || item.campaignStatus == 'Ready-to-Send'"
                  @click.stop="toggleModal(item, index)"
                >
                  {{ $t('campaign.campaignList.button.delete') }}
                </CButton>
                <transition name="fade" v-if="item._toggled">
                  <div class="dataTable__popUp popUp" @click.stop.stop>
                    <div class="popUp__body shadow-sm">
                      <ConfirmationDelete
                        :title="$t('campaign.campaignList.title-modal-delete')"
                        :description="$t('campaign.campaignList.description-modal-delete')"
                        @confirm="deleteCampaign(item, index)"
                        @cancel="closePopUpDelete(false, item, index)"
                      />
                    </div>
                  </div>
                </transition>

                <CButton
                  type="submit"
                  class="btn-gray-400 delete-campaign-arpoone"
                  color="grey"
                  :disabled="campaignIdCancelling == item.id"
                  v-if="item.campaignStatus == 'Scheduled'"
                  @click.stop="cancelCampaign(item.id)"
                >
                  <CSpinner v-if="campaignIdCancelling == item.id" class="mr-1 align-middle" color="custom-color" style="width: 1rem; height: 1rem" />
                  <span class="text-decoration-underline align-middle">{{ $t('campaign.campaignList.button.cancel') }}</span>
                </CButton>
              </div>
            </td>
          </template>

          <template #lastUpdate="{ item }">
            <td class="pr-4 font-weight-normal text-right" style="vertical-align: middle">
              <div v-if="item.campaignStatus == 'Draft' || item.campaignStatus == 'Canceled' || item.campaignStatus == 'Ready-to-Send'">
                {{ $t('campaign.campaignList.text.editedOn') }} {{ item.lastUpdate }}
              </div>
              <div v-if="item.campaignStatus == 'On-going'">
                {{ $t('campaign.campaignList.text.startedOn') }}
                {{ item.lastUpdate }}
              </div>
              <div v-if="item.campaignStatus == 'Scheduled'">
                {{ $t('campaign.campaignList.text.scheduledOn') }}
                {{ item.lastUpdate }}
              </div>
              <div v-if="item.campaignStatus == 'Sent'">
                {{ $t('campaign.campaignList.text.sentOn') }}
                {{ item.lastUpdate }}
              </div>
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </template>

    <!-- TEM AUDIENCIA, SEM LISTAGEM DE CAMPANHA E SEM FILTRO DE LISTAGEM -->
    <EmptyList
      :loading="loadingGetList"
      v-if="hasAudience && totalRecords == 0 && this.filters.Status.length == 0 && this.filters.DateTimeFim == false"
      :linkText="$t('campaign.campaignList.button.createCampaign')"
      :linkTo="{ name: 'campaign' }"
      :title="$t('campaign.campaignList.text.noCampaign')"
      :subTitle="$t('campaign.campaignList.text.createCampaign')"
    />

    <!-- SEM LISTAGEM DE CAMPANHA E NAO TEM AUDIENCIA-->
    <EmptyList
      :loading="loadingGetList"
      v-if="showEmptyMsg == false && hasAudience == false"
      :linkText="$t('audience.audienceList.button.import-contacts')"
      :linkTo="{ name: 'import-contacts' }"
      :title="$t('audience.audienceList.text.noAudience')"
      :subTitle="$t('audience.audienceList.text.importOrCreate')"
    />

    <div class="position-relative">
      <CPagination
        v-show="pages > 0 && totalRecords > 0"
        align="center"
        :pages="pages"
        :active-page.sync="activePage"
        class="dataTable__newPagination mt-3"
      >
        <template slot="previous-button">
          <span class="newPagination__button p-2 btnPagination">
            {{ $t('audience.audienceList.text.prev') }}
          </span>
        </template>
        <template slot="next-button">
          <span class="newPagination__button p-2 btnPagination">
            {{ $t('audience.audienceList.text.next') }}
          </span>
        </template>
      </CPagination>
      <CElementCover v-if="loading" :opacity="0.8" style="z-index: 1001">
        <div></div>
      </CElementCover>
    </div>
  </CCard>
</template>

<script>
import ConfirmationDelete from '@/components/ConfirmationDelete'
import MenssageAlert from '@/components/MenssageAlert'
import { dateFormatStringMed, dateTimeFormatString } from '../../../utils/dateUtil'
import EmptyList from '@/components/EmptyList'
import Engagement from '../components/Result/dashboard/Engagement.vue'
import { organizationType } from '@/utils/enumsUtils.js'

const campaignStatus = {
  1: 'Draft',
  2: 'Calculating',
  3: 'Ready-to-Send',
  4: 'Sent',
  5: 'On-going',
  6: 'Scheduled',
  7: 'Deleted',
  8: 'Pending-Balance',
  9: 'Balance-Updated',
  10: 'Pending_Outbox_Dispatch',
}

const channelTypeCode = {
  1: 'email',
  2: 'sms',
}

import services from '@/services.js'
import { mapGetters } from 'vuex'
export default {
  name: 'CampaignList',
  components: {
    MenssageAlert,
    EmptyList,
    ConfirmationDelete,
    Engagement,
  },
  data() {
    return {
      popUpDelete: false,
      columnFilterValue: {},
      observer: true,
      tableFilterValue: null,
      loadedItems: [],
      loading: false,
      headers: ['name', 'campaignStatus', 'recepients', 'channels', 'user', 'action', 'lastUpdate'],
      itemsListSelected: null,
      responsive: false,
      messages: [],
      filters: {
        Page: 1,
        Count: 10,
        Status: [],
        DateTimeFim: null,
        DateTimeIni: null,
      },
      dateRange: {
        start: '',
        end: '',
      },
      dateRangeValue: {},
      status: null,
      statusList: [],
      statusSelected: 'all-campaigns',
      searchTimeout: null,
      searchName: null,
      showEmptyMsg: null,
      // PAGINAÇÃO
      pages: 0,
      activePage: 1,
      totalRecords: 0,
      totalPages: 0,
      itemsPerPage: 10,
      loadingGetList: false,
      intervalTime: null,
      pending: false,
      pagination: [],
      engagementResultType: undefined,
      campaignIdCancelling: undefined,
    }
  },

  created() {
    this.loadingGetList = true
  },

  mounted() {
    this.getData()

    this.filterList()

    this.$root.$on('update-close-popup', () => {
      this.closePopUpDelete(true)
    })
    this.reloadTable()
  },

  beforeDestroy() {
    clearInterval(this.intervalTime)
  },

  watch: {
    reloadParams() {
      this.onTableChange()
    },
  },

  computed: {
    engagementNoDataTranslation() {
      return {
        description: this.$t('engagement.campaign-list.no-data.description'),
        state: this.$t('engagement.campaign-list.no-data.state'),
      }
    },

    organizationId() {
      return this.$route.params?.organizationId
    },

    registers() {
      return this.loadedItems.map((campaign) => {
        return {
          ...campaign,
          _selected: this.itemsListSelected == campaign.id,
          _classes: [campaign._classes, (campaign._selected = this.itemsListSelected == campaign.id ? 'table-selected' : '')],
        }
      })
    },

    hasAudience() {
      return this.$store.state.audience.hasAudience
    },

    itemsPending() {
      return 0
      // return this.loadedItems.find(item => item.statusIdto == 1)
    },

    showApproveRefuse() {
      // só mostra a featuea de aprovação se  status por pedding
      const item = this.loadedItems.find((item) => item.id == this.itemsListSelected) || null
      return item ? item.statusId == 1 : null // 1 == pedding
    },

    showAssociate() {
      // só mostra a feature de associaçao se  status por approved
      const item = this.loadedItems.find((item) => item.id == this.itemsListSelected) || null
      return item ? item.statusId == 2 : null // 2 == approved
    },

    reloadParams() {
      return [this.activePage, this.itemsPerPage, this.tableFilterValue, this.SenderStatusId, this.OrganizationStatusId, this.intervalTime]
    },

    detailPagination() {
      const first = (this.activePage - 1) * this.itemsPerPage
      const totalPage = this.activePage * 10 > this.totalRecords ? this.totalRecords : this.activePage * 10
      return `${first} - ${totalPage}  of ${this.totalRecords}`
    },

    ...mapGetters({
      lang: 'getLang',
    }),
  },

  methods: {
    reloadTable() {
      this.intervalTime = setInterval(() => {
        if (!this.loading) this.getData(false)
      }, this.$configs.VUE_APP_TIME_TABLE || 10000)
    },

    searchByName() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout)
      let self = this
      this.searchTimeout = setTimeout(() => {
        this.filters.Name = this.searchName
        this.activePage = 1
        this.onTableChange()
      }, 700)
    },

    closePopUpDelete(all = false, item, index) {
      if (all) {
        return this.toggleModalAll()
      }
      this.toggleModal(item, index)
    },

    selectChannelType(channelCode) {
      let channel = channelCode + ''
      return channelTypeCode[channel]
    },

    inputDate(date) {
      if (!date) {
        return
      }

      var inputDate = new Date(date.end)
      var currentDate = new Date()

      var currentMonth = currentDate.getMonth() + 1
      var inputMonth = inputDate.getMonth() + 1

      var start = null
      var end = null

      if (inputMonth < currentMonth) {
        start = (date?.start && new Date(date.start.setUTCHours(24))) || ''
        end = (date?.start && new Date(date.end.setUTCHours(24))) || ''
      } else {
        start = date.start
        end = date.end
      }

      this.activePage = 1
      this.filters.DateTimeIni = start
      this.filters.DateTimeFim = end

      this.dateRange = {
        start: start,
        end: end,
      }

      this.onTableChange()
    },

    toCreateSubOrganization() {
      this.$router.push({ name: 'createSubOrganization' })
    },

    formatDate(date) {
      return date ? dateTimeFormatString(date) : ''
    },

    checkFilter(statusFilter, label) {
      this.filters.Status = statusFilter
      this.statusSelected = label
      this.dateRange = {
        start: '',
        end: '',
      }
      this.filters.DateTimeIni = this.filters.DateTimeFim = null

      this.onTableChange()
    },

    toggleModal(item, index) {
      this.toggleModalAll()
      this.$set(this.loadedItems[index], '_toggled', !item._toggled)
    },

    toggleModalAll() {
      this.loadedItems.forEach((elem) => {
        this.$set(elem, '_toggled', false)
      })
    },

    filterList() {
      const IS_SENDIT = organizationType(this.$store.state.auth.session.organization.organizationType) == 'sendit'

      this.statusList = [{ value: [], label: 'all-campaigns' }]

      // 7: 'Deleted',
      // 8: 'Pending-Balance',
      // 9: 'Balance-Updated',

      for (var item in campaignStatus) {
        if (item == 7 || item == 8 || item == 9) {
          return
        }

        if (item == 2) {
          if (IS_SENDIT) {
            this.statusList.push({ value: item, label: campaignStatus[item] })
          }
        } else {
          this.statusList.push({ value: item, label: campaignStatus[item] })
        }
      }
    },

    mountItemsTable(arr) {
      let result = arr
        .filter((elm) => elm.id != this.organizationId)
        .map((elm) => {
          return {
            id: elm.id,
            organizationId: elm.organizationId,
            companyName: elm.companyName,
            dateCreated: this.formatDate(elm.createdDateTime),
            status: elm.inactiveDateTime === null ? 'Active' : 'Inactive',
            _selected: false,
            modal: false,
          }
        })
      return result
    },

    getData(loading = true) {
      this.getCampaignData(loading)
      this.getEngagementMetrics()
    },

    getCampaignData(loading) {
      this.loading = loading

      if (this.pending) {
        return
      }

      this.pending = true

      services
        .getCampaigns(this.organizationId, this.filters)
        .then((res) => {
          let pagination = res.data.data.pagination
          this.pagination = res.data.data.pagination
          this.totalRecords = pagination.totalRecords
          this.activePage = pagination.currentPage
          this.filters.Page = this.activePage
          this.pages = pagination.totalPages

          if (this.showEmptyMsg == null) {
            this.showEmptyMsg = this.totalRecords > 0
          }

          let list = res.data.data.campaigns.map((campaign) => {
            let channelTypes = []
            try {
              channelTypes = campaign.campaignWorkflow.values.reduce((ac, cv) => {
                if (ac.indexOf(cv.channel) === -1) ac.push(this.selectChannelType(cv.channel))
                return ac
              }, [])
            } catch (err) {
              // Não tem tratamento
            }

            return {
              id: campaign.campaignId,
              name: campaign.name,
              campaignStatus: campaignStatus[campaign.campaignStatus] ?? '',
              recepients: 0, // TODO alterar quando  já possuir esses dados após o processamento da campaign
              channels: this.handleChannels(channelTypes),
              notEnoughBalance: campaign.notEnoughBalance,
              user: campaign.createdBy,
              action: '',
              lastUpdate: campaign.updatedDateTime ? dateFormatStringMed(campaign.updatedDateTime) : dateFormatStringMed(campaign.autoSaveDateTime),
            }
          })

          this.loadedItems = list
        })
        .catch(() => {
          this.loadedItems = []
          this.showEmptyMsg = true
        })
        .finally(() => {
          this.loading = false
          this.loadingGetList = false
          this.pending = false
        })
    },

    async getEngagementMetrics() {
      const response = await services.getOrganizationCampaignMetrics(this.organizationId)
      this.engagementResultType = response?.data?.data?.emailAndSmsEngagement
    },

    onTableChange() {
      this.filters.Page = this.activePage
      this.getData()
    },

    paginationChange(a) {
      this.itemsPerPage = a
    },

    check(item) {
      switch (item.campaignStatus) {
        // ? Nessas condições envia para a tela de edição
        case 'Draft':
          this.$router.push({ name: 'campaignCreator', params: { campaignId: item.id } })
          break
        case 'Scheduled':
        case 'Ready-to-Send':
        case 'Balance-Updated':
          this.$router.push({ name: 'campaignSummary', params: { campaignId: item.id } })
          break
        // ? Nessas condições envia para tela de resultado
        case 'Sent':
        case 'On-going':
          this.$router.push({ name: 'campaignResult', params: { campaignId: item.id } })
          break
        case 'Calculating':
          break
        case 'Pending_Outbox_Dispatch':
          break
        case 'Pending-Balance':
          break
        default:
          break
      }
      //MVP2-1187
    },

    deleteCampaign(campaignItem, index) {
      this.toggleModal(campaignItem, index)
      this.messages = []
      services
        .deleteCampaign(this.organizationId, campaignItem.id)
        .then((res) => {
          this.messages.push({
            status: 'success',
            text: this.$t('campaign.campaignList.messages.success-delete'),
          })
          this.getData()
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
    },

    handleChannels(channels) {
      const count = channels.reduce(function (a, b) {
        a[b] = a[b] + 1 || 1
        return a
      }, {})

      return count
    },

    cancelCampaign(campaignId) {
      this.campaignIdCancelling = campaignId
      this.messages = []

      services
        .cancelCampaign(this.organizationId, campaignId)
        .then((res) => {
          this.messages.push({
            status: 'success',
            text: this.$t('campaign.campaignList.messages.success-canceled'),
          })
          this.getData()
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
        .finally(() => {
          this.campaignIdCancelling = null
        })
    },
    //Draft
  },
}
</script>

<style scoped lang="scss">
.pending {
  color: var(--warning);
}

.active,
.approved {
  color: var(--success);
}

.refused {
  color: var(--danger);
}

.listItem__download {
  cursor: pointer;
}

.listItem__name {
  flex: 0 0 20%;
  min-width: 250px;
}

.listItem__numbers {
  font-size: $font-size-xs;
  position: relative;
}

.listItem__detail {
  flex-wrap: wrap;
}

.listItem__detailItem {
  flex: 0 0 25%;
  margin-bottom: 2%;

  &.big {
    flex: 0 0 50%;
  }
}

.delete-campaign-arpoone:hover {
  color: #ff5924 !important;
}
</style>

<style module>
.blockClick {
  pointer-events: none;
}
</style>
